import { GridSortModel } from '@mui/x-data-grid-pro';

/**
 * Default pagination configuration
 */
export const DEFAULT_PAGE_SIZE = 50;

export const PAGE_SIZE_OPTIONS = [50] as const;

export const DEFAULT_PAGINATION_CONFIG = {
  defaultPageSize: DEFAULT_PAGE_SIZE,
  pageSizeOptions: PAGE_SIZE_OPTIONS,
} as const;

/**
 * Default operation modes
 */
export const DEFAULT_OPERATION_MODES = {
  sortingMode: 'client' as const,
  filterMode: 'client' as const,
} as const;

/**
 * Default sort model
 */
export const DEFAULT_SORT_MODEL: GridSortModel = [];

/**
 * DataGrid event names used across the app.
 */
export const DATA_GRID_EVENTS = {
  FILTER_MODEL_CHANGE: 'filterModelChange',
} as const;

